import { useMemo } from "react";

// Tasteful site-wide holiday touches: gentle snow + a twinkling lights garland.
// Rendered globally by Layout only when the admin has switched the Christmas theme on.
export default function ChristmasDecor() {
  const flakes = useMemo(
    () =>
      Array.from({ length: 36 }).map((_, i) => ({
        left: Math.random() * 100,
        size: 4 + Math.random() * 8,
        delay: Math.random() * 12,
        dur: 8 + Math.random() * 10,
        drift: (Math.random() * 60 - 30).toFixed(0) + "px",
        op: 0.5 + Math.random() * 0.5,
        key: i,
      })),
    []
  );

  return (
    <div aria-hidden="true" data-testid="christmas-decor">
      <div className="snow-layer">
        {flakes.map((f) => (
          <span
            key={f.key}
            className="snowflake"
            style={{
              left: `${f.left}vw`,
              width: f.size,
              height: f.size,
              opacity: f.op,
              animationDelay: `${f.delay}s`,
              animationDuration: `${f.dur}s`,
              "--drift": f.drift,
            }}
          />
        ))}
      </div>
    </div>
  );
}

// A small twinkling lights garland for just under the header.
export const LightsGarland = () => {
  const colors = ["#E87FA3", "#86C79A", "#F2CE63", "#C6ADEA", "#F2A98B", "#7FB5E8"];
  return (
    <div className="xmas-garland" aria-hidden="true" data-testid="xmas-garland">
      {Array.from({ length: 28 }).map((_, i) => (
        <span key={i} className="xmas-light" style={{ background: colors[i % colors.length], animationDelay: `${(i % 6) * 0.22}s` }} />
      ))}
    </div>
  );
};
